// src/Helpers/ProductsAPI.js

// Centralized API base URL for all product-related API calls
const runtimeProductsApi = window.appConfig?.REACT_APP_PRODUCT_API_URL;
export const ProductsAPI = runtimeProductsApi || "/api-products";


// Optionally, a function if you want flexibility later
export function getProductsApiUrl() {
  return (
    window.appConfig?.REACT_APP_PRODUCT_API_URL ||
    "/api-products"
  );
}

export function getTurnstileSiteKey() {
  return (
    window.appConfig?.REACT_APP_TURNSTILE_SITE_KEY ||
    process.env.REACT_APP_TURNSTILE_SITE_KEY ||
    ""
  );
}
